module.exports = __webpack_public_path__ + "static/img/tab444.e6d6205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabimg/tab444.png
// module id = JPYA
// module chunks = 0